import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { REQUEST_LOGALTY_CALL_BACK_MERCHANT } from './@core/constants/routes.constants';

const routes: Routes = [
  Shell.childRoutes([
    { path: 'requests', loadChildren: () => import('./requests/requests.module').then((m) => m.RequestsModule) },
  ]),
  Shell.childRoutes([
    { path: 'revolving', loadChildren: () => import('./revolving/revolving.module').then((m) => m.RevolvingModule) },
  ]),
  Shell.childRoutes([
    { path: 'activity', loadChildren: () => import('./activity/activity.module').then((m) => m.ActivityModule) },
  ]),
  Shell.childRoutes([
    { path: 'training', loadChildren: () => import('./training/training.module').then((m) => m.TrainingModule) },
  ]),
  Shell.childRoutes([
    {
      path: 'control-panel',
      loadChildren: () => import('./control-panel/control-panel.module').then((m) => m.ControlPanelModule),
    },
  ]),
  Shell.childRoutes([{ path: 'help', loadChildren: () => import('./help/help.module').then((m) => m.HelpModule) }]),
  Shell.childRoutes([
    { path: 'tech-admin', loadChildren: () => import('./tech-admin/tech-admin.module').then((m) => m.TechAdminModule) },
  ]),
  Shell.childRoutes([{ path: 'users', loadChildren: () => import('./users/users.module').then((m) => m.UsersModule) }]),
  Shell.childRoutes([
    {
      path: 'user-profiles',
      loadChildren: () => import('./user-profiles/user-profiles.module').then((m) => m.UserProfilesModule),
    },
  ]),
  Shell.childRoutes([
    { path: 'tariffs', loadChildren: () => import('./tariffs/tariffs.module').then((m) => m.TariffsModule) },
  ]),
  //Payment for certifications
  Shell.childRoutes([
    {
      path: 'paymentcert',
      loadChildren: () => import('./payment-for-certifications/payment.module').then((m) => m.PaymentModule),
    },
  ]),
  // Fallback when no prior route is matched
  Shell.childRoutes([
    {
      path: 'error/:paramError',
      loadChildren: () => import('./error-page/error-page.module').then((m) => m.ErrorPageModule),
    },
  ]),
  {
    path: 'cookies-policy',
    loadChildren: () => import('./cookies-policy/cookies-policy.module').then((m) => m.CookiesPolicyModule),
  },
  {
    path: 'accesibility',
    loadChildren: () => import('./accesibility/accesibility.module').then((m) => m.AccesibilityModule),
  },
  {
    path: 'logalty-call-back', //TODO: Do we use it?
    loadChildren: () => import('./logalty-call-back/logalty-call-back.module').then((m) => m.LogaltyCallBackModule),
  },
  {
    path: REQUEST_LOGALTY_CALL_BACK_MERCHANT,
    loadChildren: () =>
      import('./logalty-call-back-merchant/logalty-call-merchant-back.module').then(
        (m) => m.LogaltyCallBackMerchantModule
      ),
  },
  {
    path: 'logalty-call-back-image', //TODO: Do we use it?
    loadChildren: () =>
      import('./logalty-call-back-image/logalty-call-back-image.module').then((m) => m.LogaltyCallBackImageModule),
  },
  {
    path: 'comprobacionPing',
    loadChildren: () => import('./ping/ping.module').then((m) => m.PingModule),
  },
  {
    path: 'landing-videoselfing',
    loadChildren: () =>
      import('./landing-videoselfing/landing-videoselfing.module').then((m) => m.LandingVideoselfingModule),
  },
  {
    path: 'landing-finish-videoselfing',
    loadChildren: () =>
      import('./landing-finish-videoselfing/landing-finish-videoselfing.module').then(
        (m) => m.LandingFinishVideoselfingModule
      ),
  },
  {
    path: 'landing-onfido-videoselfing',
    loadChildren: () =>
      import('./landing-onfido-videoselfing/landing-onfido-videoselfing.module').then(
        (m) => m.LandingOnfidoVideoselfingModule
      ),
  },
  {
    path: 'landing-onfido-videoselfing',
    loadChildren: () =>
      import('./landing-onfido-videoselfing/landing-onfido-videoselfing.module').then(
        (m) => m.LandingOnfidoVideoselfingModule
      ),
  },

  /** NUEVO Lazy Loading */
  {
    path: 'logalty-signature-thirdParty',
    loadChildren: () =>
      import('./third-party-signature/third-party-signature.module').then((m) => m.ThridPartySignatureModule),
  },
  {
    path: 'logalty-signature-async',
    loadChildren: () =>
      import('./logalty-signature-async/logalty-signature-async.module').then((m) => m.LogaltySignatureAsyncModule),
  },
  {
    path: 'videoselfing-consent',
    loadChildren: () =>
      import('./videoselfing-consent/videoselfing-consent.module').then((m) => m.VideoselfingConsentDialogModule),
  },
  {
    path: 'logalty-signature-async-merchant',
    loadChildren: () =>
      import('./logalty-signature-async-merchant/logalty-signature-async-merchant.module').then(
        (m) => m.LogaltySignatureAsyncMerchantModule
      ),
  },
  /** FIN Nuevos Lazy Loading */

  { path: '**', redirectTo: 'error/404', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
